const Footer = () => {
    return (
        <p className='clearfix mb-0 text-center text-dark'>
            <span>
                <span className='d-none d-sm-inline-block'>طراحی و تولید توسط ,</span>
                <a href='https://barantm.ir' target='_blank' rel='noopener noreferrer'>
                    <b className="text-dark">
                        شرکت توسعه نرم افزاری باران
                    </b>
                </a>
            </span>
            <span>
                 <i className="fa fa-copyright ml-1"></i>
                {new Date().getFullYear()}{' '}
            </span>
        </p>
    )
}

export default Footer
